<div class="light-rounded shadow-card p-3 alert-message bg-white-gradient {{type}} mb-4">
  <div class="content d-flex align-items-center">
    <div class="px-3 d-flex align-items-center">
      <i class="fa-solid fa-circle-info" *ngIf="type === 'info' || type === 'bluesky'"></i>
      <i class="fa-solid fa-triangle-exclamation" *ngIf="type === 'error'"></i>
      <i class="fa-solid fa-triangle-exclamation" *ngIf="type === 'warning'"></i>
      <i class="fa-solid fa-triangle-exclamation" *ngIf="type === 'secondary'"></i>
    </div>
    <div class="pr-3">
      <div class="font-weight-bold">
        <span *ngIf="title">{{title}}</span>
        <span *ngIf="!title && (type === 'info' || type === 'bluesky')" translate>Information</span>
        <span *ngIf="!title && type === 'error'" translate>Erreur</span>
        <span *ngIf="!title && type === 'warning'" translate>Attention</span>
        <span *ngIf="!title && type === 'secondary'" translate>Information</span>
      </div>
      <div class="text-primary text-md mt-2">{{message}}</div>
    </div>
    <div (click)="close()" class="d-flex ml-3 pointer">
      <i class="fa-solid fa-xmark"></i>
    </div>
  </div>
</div>
